import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styled'
import truncate from '../../utils/truncate'

const NewsCard = ({ node, categories }) => {
  const {
    image: {
      localFile: {
        childImageSharp: {
          fluid: { src },
        },
      },
    },
  } = node.data

  return (
    <S.Item>
      <S.StyledLink to={`/${node.uid}`}>
        <S.Card>
          <S.ImageWrapper>
            <S.BackgroundImage src={src} />
          </S.ImageWrapper>
          {categories.map((cat, i) => (
            <S.CardLabel key={cat}>
              {!!i && ' / '} {cat}
            </S.CardLabel>
          ))}
          <S.Headline>{node.data.title.text}</S.Headline>
          <S.Description>{truncate(node.data.description, 80)}</S.Description>
          <S.Date>{node.data.date}</S.Date>
        </S.Card>
      </S.StyledLink>
    </S.Item>
  )
}

export default NewsCard

NewsCard.propTypes = {
  node: PropTypes.object.isRequired,
  categories: PropTypes.array.isRequired,
}
